export const CONFIG_MAPPING: { [host: string]: string } = {
	'dashboard.staging.zesty.co': 'staging.config.json',
	'bo.staging.zesty.co': 'bo.staging.config.json',
	'dashboard-q1.staging.zesty.co': 'staging.config.json',
	'dashboard-q2.staging.zesty.co': 'staging.config.json',
	'dashboard-q3.staging.zesty.co': 'staging.config.json',
	'partnertest.staging.zesty.co': 'partnertest.config.json',
	'localhost:3000': 'local.config.json',
	'localhost:3001': 'bo.local.config.json',
	'appa.zesty.co': 'prod.config.json',
	'app.zesty.co': 'prod.config.json',
	'bo.zesty.co': 'bo.prod.config.json',
	// Our domain
	'allcloudus.zesty.co': 'allcloudus.config.json',
	'appdirect.zesty.co': 'appdirect.config.json',
	'flexa.zesty.co': 'flexa.config.json',
	'ixperf.zesty.co': 'ixperf.config.json',
	'convergetp.zesty.co': 'convergetp.config.json',
	'acmadv.zesty.co': 'acmadv.config.json',
	'skypurple.zesty.co': 'skypurple.config.json',
	'hykell.zesty.co': 'hykell.config.json',
	'trustsoft.zesty.co': 'trustsoft.config.json',
	'alphaus.zesty.co': 'alphaus.config.json',
	'cloudride.zesty.co': 'cloudride.config.json',
	'kloia.zesty.co': 'kloia.config.json',
	'atlas7.zesty.co': 'atlas7.config.json',
	'revolgy.zesty.co': 'revolgy.config.json',
	'directeam.zesty.co': 'directeam.config.json',
	'cloudlife.zesty.co': 'cloudlife.config.json',
	'acecloud.zesty.co': 'acecloud.config.json',
	'playgroundtech.zesty.co': 'playgroundtech.config.json',
	'terasky.zesty.co': 'terasky.config.json',
	'dcsolution.zesty.co': 'dcsolution.config.json',
	'bridgetek.zesty.co': 'bridgetek.config.json',
	'redapt.zesty.co': 'redapt.config.json',
	'alignedtg.zesty.co': 'alignedtg.config.json',
	'spirit21.zesty.co': 'spirit21.config.json',
	'comm-it.zesty.co': 'commit.config.json',
	'allcloud.zesty.co': 'allcloud.config.json',
	'hitachivantara.zesty.co': 'hitachivantara.config.json',
	'pax8.zesty.co': 'pax8.config.json',
	'v8tech.zesty.co': 'v8tech.config.json',
	'dmoove.zesty.co': 'dmoove.config.json',
	'dnxbrasil.zesty.co': 'dnxbrasil.config.json',
	'esxtech.zesty.co': 'esxtech.config.json',
	'datacomau.zesty.co': 'datacomau.config.json',
	'wangsu.zesty.co': 'wangsu.config.json',
	'8west.zesty.co': '8west.config.json',
	'dcode.zesty.co': 'dcode-tech.config.json',
	// Separate domain
	'sharesave.nops.io': 'nops.config.json',
	'cloudsavings.cbts.com': 'cbts.config.json',
	'cost.enkel.com.br': 'enkel.config.json',
	'app.dtcs.io': 'dtcs.config.json',
	'app.ibexlabs.com': 'ibexlabs.config.json',
	'finportal.globaldots.com': 'globaldots.config.json',
	'zesty.cloudreach.com': 'cloudreach.config.json',
	'cloudcostmanaged.cloudblue.com': 'ingrammicro.config.json',
	'finops.midlink.co.il': 'midlink.config.json',
	'finopsportal.plusserver.com': 'plusserver.config.json',
	'app.2bcloud.io': '2bcloud.config.json',
	'app.simoda.co.uk': 'simoda.config.json',
	'savings-manager.ackstorm.com': 'ackstorm.config.json',
	'cloudoptimizer.cmi.chinamobile.com': 'chinamobile.config.json',
	'dashboard.renovacloud.com': 'renova.config.json',
	'app.fxinnovation.com': 'fxinnovation.config.json',
	'app.cloudadvisorsinc.com': 'cloudadvisors.config.json',
	'dashboard.oakrocket.com': 'oakrocket.config.json',
};
